import {DsquaresLogo} from "src/assets/Icons";
import { useTranslation } from "react-i18next";

export default function WelcomeSplash() {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();
  return (
    <div className="from-background-primary to-background-primary-light hidden w-3/5 flex-col bg-gradient-to-br px-[4.5rem] py-[2.75rem] lg:flex">
      <DsquaresLogo className="flex h-20 w-20 flex-shrink-0 pb-0" />
      <div className="mb-auto mt-auto flex flex-col justify-center" style={{ paddingTop: "8rem" }}>
        <p className="text-font-inverted/60 text-lg font-normal uppercase tracking-wide" style={{ letterSpacing: "0.1em" }}>
          {t("Login.platformLabel")}
        </p>
        <h1 className="mt-4 max-w-[34rem] text-5xl font-semibold leading-tight text-font-inverted">{t("Login.heroTitle")}</h1>
        <p className="text-font-inverted/72 mt-5 max-w-[30rem] text-lg font-light leading-relaxed">
          {t("Login.heroSubtitle")}
        </p>
      </div>
      <p className="text-font-inverted/50 text-sm font-medium">
        © {currentYear} {t("Login.allRightsReserved")}
      </p>
    </div>
  );
}
